// src/Contact.js
import React from 'react';
import './Contact.css'; // Import the CSS file for the Contact page

const Contact = () => {
  return (
    <section className="contact-section">
      <div className="contact-container" data-aos="fade-up">
        <h2 className="contact-title" data-aos="fade-down">Contact Us</h2>
        <div className="contact-content">
          {/* Left Div: Contact Information */}
          <div className="contact-info" data-aos="fade-right">
            <h3 className="contact-info-title">Issues? Questions? Suggestions? We're here for you</h3>
            <div className="contact-info-list">
              <div className="contact-info-item" data-aos="fade-right" data-aos-delay="100">
                <img src={`${process.env.PUBLIC_URL}/images/ic_outline-email.svg`} alt="email icon" className="contact-info-icon" />
                <a href="mailto:info@simplyigbo.com" className="contact-info-link">info@simplyigbo.com</a>
              </div>
              <div className="contact-info-item" data-aos="fade-right" data-aos-delay="200">
                <img src={`${process.env.PUBLIC_URL}/images/ph_phone-bold.svg`} alt="phone icon" className="contact-info-icon" />
                <a href="tel:+1234567890" className="contact-info-link">+1234567890</a>
              </div>
              <div className="contact-info-item" data-aos="fade-right" data-aos-delay="300">
                <img src={`${process.env.PUBLIC_URL}/images/prime_twitter.svg`} alt="twitter icon" className="contact-info-icon" />
                <a href="https://twitter.com/simplyigbo" target="_blank" rel="noopener noreferrer" className="contact-info-link">Twitter</a>
              </div>
              <div className="contact-info-item" data-aos="fade-right" data-aos-delay="400">
                <img src={`${process.env.PUBLIC_URL}/images/logos_facebook.svg`} alt="facebook icon" className="contact-info-icon" />
                <a href="https://www.facebook.com/simplyigbo" target="_blank" rel="noopener noreferrer" className="contact-info-link">Facebook</a>
              </div>
              <div className="contact-info-item" data-aos="fade-right" data-aos-delay="500">
                <img src={`${process.env.PUBLIC_URL}/images/skill-icons_instagram.svg`} alt="instagram icon" className="contact-info-icon" />
                <a href="https://www.instagram.com/simplyigbo" target="_blank" rel="noopener noreferrer" className="contact-info-link">Instagram</a>
              </div>
            </div>
          </div>
          {/* Right Div: Contact Form */}
          <div className="contact-form-container" data-aos="fade-left">
            <form action="/contact" method="POST">
              <div className="form-group">
                <label htmlFor="name" className="form-label">Name</label>
                <input type="text" id="name" name="name" className="form-input" required />
              </div>
              <div className="form-group">
                <label htmlFor="email" className="form-label">Email</label>
                <input type="email" id="email" name="email" className="form-input" required />
              </div>
              <div className="form-group">
                <label htmlFor="subject" className="form-label">Subject</label>
                <input type="text" id="subject" name="subject" className="form-input" required />
              </div>
              <div className="form-group">
                <label htmlFor="message" className="form-label">Message</label>
                <textarea id="message" name="message" rows="4" className="form-textarea" required></textarea>
              </div>
              <div className="form-submit">
                <button type="submit" className="form-button">Send Message</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;